export const soundboardSoundHydration = {
    keyMapping: {
        _id: "id",
        creator_id: "creatorId",
        file_id: "fileId",
    },
    functions: {
        id: (sound) => sound._id,
        parent: (sound) => sound.parent,
        creatorId: (sound) => sound.creator_id,
        name: (sound) => sound.name,
        emoji: (sound) => sound.emoji,
        fileId: (sound) => sound.file_id,
        volume: (sound) => (typeof sound.volume === "number" ? sound.volume : 100),
    },
    initialHydration: () => ({}),
};
